import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import CategoriesPage from './pages/CategoriesPage';
import ItemsPage from './pages/ItemsPage';
import JobsPage from './pages/JobsPage';
import InventorySummaryPage from './pages/InventorySummaryPage';
import AddInventoryPage from './pages/AddInventoryPage';
import BulkRemoveInventoryPage from './pages/BulkRemoveInventoryPage';
import BulkReconcilePage from './pages/BulkReconcilePage';
import TransactionLedgerPage from './pages/TransactionLedgerPage';
import ImportPage from './pages/ImportPage';
import LotsPage from './pages/LotsPage';
import UsersPage from './pages/UsersPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import ReportsPage from './pages/ReportsPage';
import InventoryValueReportPage from './pages/InventoryValueReportPage';

function App() {
  return (
    <AuthProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/categories"
              element={
                <ProtectedRoute>
                  <CategoriesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/items"
              element={
                <ProtectedRoute>
                  <ItemsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/jobs"
              element={
                <ProtectedRoute>
                  <JobsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/inventory"
              element={
                <ProtectedRoute>
                  <InventorySummaryPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lots"
              element={
                <ProtectedRoute>
                  <LotsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/inventory/add"
              element={
                <ProtectedRoute>
                  <AddInventoryPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/inventory/remove"
              element={
                <ProtectedRoute>
                  <BulkRemoveInventoryPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/inventory/reconcile"
              element={
                <ProtectedRoute>
                  <BulkReconcilePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/transactions"
              element={
                <ProtectedRoute>
                  <TransactionLedgerPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/import"
              element={
                <ProtectedRoute>
                  <ImportPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/account/change-password"
              element={
                <ProtectedRoute>
                  <ChangePasswordPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <ProtectedRoute>
                  <ReportsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports/inventory-value"
              element={
                <ProtectedRoute>
                  <InventoryValueReportPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/users"
              element={
                <ProtectedRoute requireAdmin>
                  <UsersPage />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
